import { Modal, Text, toastSuccess, useDisclosure } from "@alpacahq/ui/old";

import { useLiquidatePosition } from "~/v2/api/hooks";
import type { Account, Position, Product } from "~/v2/api/rest/account";
import type { OptionContract } from "~/v2/api/rest/data";
import { CountdownButton } from "../CountdownButton";

interface CloseContractProps {
  product?: Product;
  position: Position;
  account: Account;
  contract: OptionContract | undefined;
}

export const CloseContract = ({
  product,
  position,
  account,
  contract,
}: CloseContractProps) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const mutation = useLiquidatePosition({
    onSuccess: () => {
      toastSuccess("Position liquidated");
    },
    onSettled: () => {
      onClose();
    },
  });

  const onConfirm = async () =>
    mutation.mutate({
      product,
      symbol: contract?.symbol || "",
      accountID: account?.id || "",
      cancelOrders: true,
    });

  return (
    <>
      {!!position && (
        <button
          type="button"
          // @todo This is just a temporary styling (we're moving fast OK?)
          className="flex h-10 cursor-pointer items-center justify-center rounded-lg bg-zinc-100 px-4 font-medium text-sm transition-all duration-400 ease-in-out hover:bg-zinc-200"
          onClick={onOpen}
          disabled={mutation.isPending}
        >
          Close Position
        </button>
      )}
      <Modal
        title="Close Position"
        isOpen={isOpen}
        onClose={onClose}
        controls={
          <div className="flex items-center justify-between gap-4">
            <button
              type="button"
              onClick={onClose}
              // @todo This is just a temporary styling (we're moving fast OK?)
              className="flex h-10 cursor-pointer items-center justify-center rounded-lg bg-zinc-100 px-4 font-medium text-sm transition-all duration-400 ease-in-out hover:bg-zinc-200"
            >
              Back
            </button>
            <CountdownButton onConfirm={onConfirm} />
          </div>
        }
      >
        <Text>
          Are you sure you want to close your position in{" "}
          <span className="bg-blue-100 px-0.5 text-blue-600 text-sm">
            {contract?.symbol}
          </span>
          ? This action cannot be undone.
        </Text>
      </Modal>
    </>
  );
};
